import Vue from 'vue';

import {
    Button,
    CellGroup,
    Field,
    RadioGroup,
    Radio,
    Swipe,
    SwipeItem,
    Notify,
    DatetimePicker,
    Popup
} from 'vant';

Notify.setDefaultOptions({
    color: '#fff',
    background: 'rgba(0,0,0,.8)',
    duration: 1000
})
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Notify);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);